var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('expandable-text',{attrs:{"text":_vm.subheading,"maxLength":100}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }